const UNITS = [
  { value: 1e12, suffix: 'T' },
  { value: 1e9, suffix: 'B' },
  { value: 1e6, suffix: 'M' },
  { value: 1e3, suffix: 'k' }, // lower-case 'k' as requested
]

function trimZeros(s: string) {
  // "1.0" -> "1", "1.50" -> "1.5"
  return s.replace(/(?:\.0+|(\.\d*[1-9])0+)$/, '$1')
}

/**
 * Format large numbers into 1k, 1M, 1B, 1T.
 * @param input number to format
 * @param decimals max fraction digits (default 1)
 */
export function formatCount(input: number | bigint, decimals = 1): string {
  const n = typeof input === 'bigint' ? Number(input) : input
  if (!Number.isFinite(n)) return String(input)

  const sign = n < 0 ? '-' : ''
  const abs = Math.abs(n)

  if (abs < 1000) return sign + abs.toString() // show plain for small numbers

  for (let i = 0; i < UNITS.length; i++) {
    const { value, suffix } = UNITS[i]
    if (abs >= value) {
      const raw = abs / value
      const rounded = Number(raw.toFixed(decimals))

      // Handle roll-up (e.g., 999.95k -> 1.0M)
      if (rounded >= 1000 && i > 0) {
        const next = UNITS[i - 1]
        const bumped = abs / next.value
        return sign + trimZeros(bumped.toFixed(decimals)) + next.suffix
      }

      return sign + trimZeros(rounded.toFixed(decimals)) + suffix
    }
  }

  // Fallback (shouldn't hit because 1e12 covered)
  return sign + abs.toString()
}
